import React, {useContext, useEffect} from 'react'
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {Form, InputNumber} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const OfferUpdatePrice = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent

    useEffect(() => {
        form.setFieldsValue({
            [`price-${rowIndex}`]: record.linePrice
        })
    }, [rowIndex, record])

    const handlePriceChange = ({target}) => {
        const newList = replaceIndexAt(
            bidList,
            {
                ...record,
                linePrice: target.value
            },
            rowIndex
        )
        setBidList(newList)
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item
                    name={`price-${rowIndex}`}
                    rules={[{required: true, message: 'Bu Alan Zorunludur'}]}
                >
                    <InputNumber step={0.1} onBlur={handlePriceChange}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdatePrice